import { postApiRtt } from "@/util/performance";

let deferredPrompt = null; // 用来存储beforeinstallprompt以便于处理pwa installation相关操作
window.addEventListener("beforeinstallprompt", (e) => {
  console.log("--------展示pwa，捕获beforeinstallprompt-------");
  // Prevent the mini-infobar from appearing on mobile (chrome 67 and earlier)
  // showing prompt
  e.preventDefault();
  // Stash the event so it can be triggered later.
  deferredPrompt = e;
  // this.showIfValid();
});

export function addToPwa() {
  console.log("----开始添加pwa-----");
  deferredPrompt.prompt();
  postApiRtt("pwa_popup_impression_and");
  // Wait for the user to respond to the prompt
  deferredPrompt.userChoice.then((choiceResult) => {
    if (choiceResult.outcome === "accepted") {
      console.log("User accepted the install prompt");
      postApiRtt("pwa_popup_install_click");
    } else {
      console.log("User dismissed the install prompt");
      postApiRtt("pwa_popup_cancel_click");
    }
    deferredPrompt = null;
  });
}
